function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 505 505",
    style: {
      enableBackground: "new 0 0 505 505"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "193.6,93.7 193.6,153.5 133.9,153.5 133.9,409.4 371.8,409.4 371.8,93.7 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E9EE"
    },
    points: "193.6,93.7 133.9,153.5 193.6,153.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M326,179.7l-34.9,34.9V196c0-8.5-6.9-15.3-15.3-15.3h-80.9c-8.5,0-15.3,6.9-15.3,15.3v62.8 c0,8.5,6.9,15.3,15.3,15.3h80.9c8.5,0,15.3-6.9,15.3-15.3v-18.6l34.9,34.9V179.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.768,
    y: 328.667,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 295.5695 -22.9335)",
    style: {
      fill: "#F9B54C"
    },
    width: 17.4,
    height: 33.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M181.8,339.1c21.8,21.8,57.1,21.8,78.8,0c21.8-21.8,21.8-57.1,0-78.8c-21.8-21.8-57.1-21.8-78.8,0 C160,282,160,317.3,181.8,339.1z M191,269.5c16.6-16.6,43.6-16.6,60.3,0c16.6,16.6,16.6,43.6,0,60.3c-16.6,16.6-43.6,16.6-60.3,0 C174.4,313.2,174.4,286.2,191,269.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C0EB"
    },
    d: "M160.2,339.9l20.7,20.7c0.6,0.6,0.6,1.4,0,2l-50,50c-0.6,0.6-1.4,0.6-2,0l-20.7-20.7 c-0.6-0.6-0.6-1.4,0-2l50-50C158.8,339.3,159.7,339.3,160.2,339.9z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.cc376753.svg";
export { ForwardRef as ReactComponent };